//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AdyenPaymentResultInput, AdyenPaymentStatusResponse, AdyenRefundRequest, AdyenRefundResponse, AdyenSessionRequest, AdyenSessionResponse, FileResponse, Webhook } from './types';


export interface IAdyenPaymentClient {

    /**
     * Creates an Adyen Drop-in payment session using the current seller account's Adyen credentials.
     */
    createPaymentSession(request: AdyenSessionRequest): Promise<AdyenSessionResponse>;

    /**
     * Submits the payment result from the frontend after the buyer completes the Adyen Drop-in flow.
    Updates the sale's payment state accordingly.
     * @param saleId (optional) 
     */
    submitPaymentResult(saleId: number | undefined, input: AdyenPaymentResultInput): Promise<AdyenPaymentStatusResponse>;

    /**
     * Initiates a full refund for a previously authorised payment.
    Looks up the original payment session by MerchantReference and refunds the full amount.
     */
    refundPayment(request: AdyenRefundRequest): Promise<AdyenRefundResponse>;

    /**
     * Webhook endpoint for Adyen payment notifications.
    Authentication is done via HMAC signature validation, not user auth.
    Extracts buyer info and credit card summary on successful payment.
     */
    webhookNotification(): Promise<FileResponse>;
}

export class AdyenPaymentClient extends PosClientBase implements IAdyenPaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates an Adyen Drop-in payment session using the current seller account's Adyen credentials.
     */
    createPaymentSession(request: AdyenSessionRequest, signal?: AbortSignal | undefined): Promise<AdyenSessionResponse> {
        let url_ = this.baseUrl + "/api/AdyenPayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePaymentSession(_response);
        });
    }

    protected processCreatePaymentSession(response: Response): Promise<AdyenSessionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdyenSessionResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdyenSessionResponse>(null as any);
    }

    /**
     * Submits the payment result from the frontend after the buyer completes the Adyen Drop-in flow.
    Updates the sale's payment state accordingly.
     * @param saleId (optional) 
     */
    submitPaymentResult(saleId: number | undefined, input: AdyenPaymentResultInput, signal?: AbortSignal | undefined): Promise<AdyenPaymentStatusResponse> {
        let url_ = this.baseUrl + "/api/AdyenPayment/SubmitPaymentResult?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitPaymentResult(_response);
        });
    }

    protected processSubmitPaymentResult(response: Response): Promise<AdyenPaymentStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdyenPaymentStatusResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdyenPaymentStatusResponse>(null as any);
    }

    /**
     * Initiates a full refund for a previously authorised payment.
    Looks up the original payment session by MerchantReference and refunds the full amount.
     */
    refundPayment(request: AdyenRefundRequest, signal?: AbortSignal | undefined): Promise<AdyenRefundResponse> {
        let url_ = this.baseUrl + "/api/AdyenPayment/RefundPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefundPayment(_response);
        });
    }

    protected processRefundPayment(response: Response): Promise<AdyenRefundResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdyenRefundResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdyenRefundResponse>(null as any);
    }

    /**
     * Webhook endpoint for Adyen payment notifications.
    Authentication is done via HMAC signature validation, not user auth.
    Extracts buyer info and credit card summary on successful payment.
     */
    webhookNotification(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AdyenPayment/WebhookNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWebhookNotification(_response);
        });
    }

    protected processWebhookNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}
